const brandsQueryKeys = {
  all: ['all', 'brands'] as const,
  brandLists: () => [...brandsQueryKeys.all, 'brandList'] as const,
  brandList: (search: string, params?: string) => [...brandsQueryKeys.brandLists(), { search }, params || ''] as const,
}

export default brandsQueryKeys
